import React from 'react';
import {Button,Modal} from 'react-bootstrap';
import { useState,useEffect } from 'react';
import { getLocalCajaManagementByLocalId } from '../../../../../../../../../../crud/management_api/locales_caja_management';
import { moveMoneyFromCajaToCaja } from '../../../../../../../../../../crud/management_api/locales_caja_management';
import { X } from 'react-bootstrap-icons';
import {toast} from 'react-toastify';
import './IsCajaWithMoney.scss';
import { Dropdown } from 'react-bootstrap';
import { IoMdArrowDropdown } from 'react-icons/io';


type Props = {
  id_workstation: number;
  show: boolean;
  onClose: (transferDone: boolean) => void;
}


export const IsCajaWithMoney = (props: Props) => {
  const { id_workstation, show, onClose } = props;
  const [cajas, setCajas] = useState<any[]>([]);
  const [selectedCaja, setSelectedCaja] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show) return;
    const userContext = localStorage.getItem('user');
    const localId = userContext ? JSON.parse(userContext).local_id : 0;
    const fetchCajas = async () => {
      const response = await getLocalCajaManagementByLocalId(localId);
      const filteredCajas = response.data.filter(
        (caja: any) => caja.workstation_id !== id_workstation && caja.is_open === true
      );
      setCajas(filteredCajas);
    };
    fetchCajas();
  }, [id_workstation, show]);

  const handleCancel = () => {
    onClose(false); // No se realizó transferencia
  };

  const selectedLabel =
    (selectedCaja && cajas.find(c => c.workstation_id === selectedCaja)?.workstation_name) ||
    'Selecciona una caja';

  const handleConfirm = async () => {
    if (!selectedCaja) {
      toast.error('Selecciona una caja destino.');
      return;
    }
    setLoading(true);
    try {
      await moveMoneyFromCajaToCaja(id_workstation, selectedCaja);
      onClose(true); // Transferencia realizada
      } catch (error: any) {
        let errorMessage = 'Error desconocido';
        if (error?.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error?.message) {
          errorMessage = error.message;
        }
        toast.error('Error al transferir dinero: ' + errorMessage);
      }
};

  return (
    <Modal className='modal-is-caja-with-money' show={show} onHide={handleCancel} backdrop="static" centered>
      <Modal.Header>
        <div className='form-modal-title-container'>
          <Modal.Title className='form-modal-title'>Transferir dinero antes de desmarcar como caja</Modal.Title>
        </div>
        <Button variant="none" className="modal-close-button" onClick={handleCancel}>
          <X size={24} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <p>Esta caja aún tiene dinero. Debes transferirlo a otra caja antes de continuar.</p>
        <div style={{ marginBottom: 12 }}>
          <label>Selecciona la caja destino:</label>
          <Dropdown>
            <Dropdown.Toggle className="dropdown" id="dropdown-caja-destino">
              {selectedLabel} <IoMdArrowDropdown />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {cajas.map((caja) => (
                <Dropdown.Item
                  key={caja.workstation_id}
                  onClick={() => setSelectedCaja(caja.workstation_id)}
                >
                  {caja.workstation_name}
                </Dropdown.Item>
              ))}
              
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="none" className='form-button-cancel' onClick={handleCancel} disabled={loading}>
          Cancelar
        </Button>
        <Button variant="none" className='form-button-create' onClick={handleConfirm} disabled={loading}>
          {loading ? 'Transfiriendo...' : 'Transferir y continuar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};